export const collectionPage = {
    'collection.page.title': '{collectionName} | Toy Collections | R.Toys',
    'collection.page.description': 'Explore the "{collectionName}" collection, which includes unique NFT and physical toys. This themed collection of toys is designed for true connoisseurs.',
}
